{
  "domain": "dev-3md2d2gxrc7nhoyk.us.auth0.com",
  "clientId": "6N1oe7tcMksroM12uA6gY37QzmeuNCci",


  "authorizationParams": {
    "audience": "https://bmx/api"
  },
  "apiUri": "https://bmxv2.azurewebsites.net",
  "appUri": "http://devlocal.wannabook.online:4200",
  "errorPath": "/error",
  "audience": "https://bmx/api"

}
